import { FC } from 'react'

import { useWallet } from '@aptos-labs/wallet-adapter-react'
import { ModalProps, Tooltip } from '@mantine/core'
import { useClipboard } from '@mantine/hooks'
import { ReactComponent as Copy } from 'assets/copy.svg'
import Jazzicon, { jsNumberForAddress } from 'react-jazzicon'

import { ButtonGradient } from 'components/ButtonGradient'
import CustomModal from 'components/CustomModal'
import { cx } from 'utils/cx'
import { shortAddress } from 'utils/shortAddress'

import s from './s.module.scss'

type Props = {
  disconnectButtonClassName?: string
} & ModalProps

const DisconnectWalletModal: FC<Props> = ({ disconnectButtonClassName, ...props }) => {
  const { account, disconnect, wallet } = useWallet()
  const { copy } = useClipboard()

  const onCloseModal = () => {
    props.onClose()
  }

  const onCopy = () => {
    copy(account.address)
  }
  const onDisconnect = () => {
    disconnect()
    props.onClose()
  }

  return (
    <CustomModal
      {...props}
      classNames={{
        content: s.inner,
      }}
      onClose={onCloseModal}
    >
      <section className={s.info}>
        <div className={s.infoWallet}>
          <img alt="wallet" height={36} src={wallet.icon} width={36} />
          <div className={s.description}>
            <span className={s.title}>Wallet Name</span>
            <span>{wallet.name}</span>
          </div>
        </div>
        <div className={s.infoAccount}>
          <Jazzicon diameter={36} seed={jsNumberForAddress(account.address)} />
          <div className={s.description}>
            <span className={s.title}>Account Address</span>
            <Tooltip label={account.address}>
              <span>{shortAddress(account.address)}</span>
            </Tooltip>
          </div>
          <button aria-label="onCopy" className={s.copyButton} onClick={onCopy}>
            <Copy />
          </button>
        </div>
      </section>
      <ButtonGradient className={cx(s.disconnectButton, disconnectButtonClassName)} onClick={onDisconnect}>
        Disconnect
      </ButtonGradient>
    </CustomModal>
  )
}

export default DisconnectWalletModal
